const calculateRiskScore = (responses, sectionA) => {
  let score = 0;

  // Helper function to get value with default to false (No)
  const getValue = (key) => {
    return responses && responses[key] === true ? true : false;
  };

  // Section A - Qualification (if not applicable, score = 0)
  const sectionAKeys = ['A1.1', 'A1.2', 'A1.3', 'A1.4', 'A1.5'];
  const hasApplicability = sectionAKeys.some(key => sectionA && sectionA[key] === true);
  if (!hasApplicability) {
    return { score: 0, level: 'Low Risk' };
  }

  // Section B - Data Inventory
  // Default to false (No) for all questions - only calculate when explicitly Yes
  if (getValue('B1.2')) score += 5; // Financial data
  if (getValue('B1.3')) score += 8; // Government IDs
  if (getValue('B1.4')) score += 5; // Employment data
  if (getValue('B1.5')) score += 10; // Health data
  if (getValue('B1.6')) score += 10; // Biometric data
  if (getValue('B1.7')) score += 3; // Behavioural data
  if (getValue('B1.8')) score += 15; // Minors data (high risk)
  if (getValue('B1.9')) score += 8; // Sensitive data
  if (getValue('B1.10')) score += 5; // Large volume
  // For "No" answers, default to false (No) if not answered
  if (!getValue('B1.9A')) score += 5; // No DPO
  if (!getValue('B1.9B')) score += 5; // No governance framework

  // Section C - Consent & Rights
  // Default to false (No) - only calculate when explicitly No (meaning they don't have it)
  if (!getValue('C1.1')) score += 8; // No explicit consent
  if (!getValue('C1.2')) score += 3; // No plain language notices
  if (!getValue('C1.3')) score += 5; // Cannot withdraw consent
  if (!getValue('C1.4')) score += 3; // No consent logs
  if (!getValue('C2.1')) score += 8; // No rights workflow
  if (!getValue('C2.2')) score += 5; // No tracking
  if (!getValue('C2.3')) score += 5; // No DPM

  // Section D - Minimization & Retention
  if (!getValue('D1.1')) score += 5; // Over-collection
  if (!getValue('D1.2')) score += 3; // No prevention
  if (!getValue('D2.1')) score += 8; // No retention policy
  if (!getValue('D2.2')) score += 8; // No secure deletion
  if (!getValue('D2.3')) score += 3; // No review

  // Section E - Security
  if (!getValue('E1.1')) score += 5; // No access controls
  if (!getValue('E1.2')) score += 5; // No encryption
  if (!getValue('E1.3')) score += 5; // No endpoint security
  if (!getValue('E1.4')) score += 8; // No server encryption
  if (!getValue('E1.5')) score += 5; // No MFA
  if (!getValue('E2.1')) score += 5; // No vulnerability assessments
  if (!getValue('E2.2')) score += 8; // No breach SOP
  if (!getValue('E2.3')) score += 5; // Vendor security issues
  if (!getValue('E2.4')) score += 3; // No monitoring

  // Section F - Third-party
  if (getValue('F1') && getValue('F2')) {
    if (!getValue('F3')) score += 10; // No DSA
    if (!getValue('F4')) score += 8; // No vendor audit
  }
  if (getValue('F5')) score += 5; // Free/trial tools

  // Section G - Cross-border
  if (getValue('G1')) {
    if (getValue('G2') && !getValue('G3')) score += 10; // No safeguards
  }

  // Section H - Training
  if (!getValue('H1')) score += 5; // No training
  if (!getValue('H2')) score += 3; // No awareness
  if (!getValue('H3')) score += 3; // No training logs

  // Section I - Governance
  const requiredDocs = ['I1.1', 'I1.2', 'I1.3', 'I1.4', 'I1.5', 'I1.6'];
  requiredDocs.forEach(doc => {
    if (!getValue(doc)) score += 3;
  });
  if (!getValue('I2')) score += 5; // No management awareness
  if (!getValue('I3')) score += 5; // No CXO oversight

  // Section J - High-risk sectors
  // Financial Services
  if (getValue('J1.1')) score += 5;
  if (getValue('J1.2')) score += 8;
  if (getValue('J1.3')) score += 5;
  if (getValue('J1.4') && !getValue('J1.5')) score += 5;

  // Healthcare
  if (getValue('J2.1')) score += 10;
  if (getValue('J2.2') && getValue('J2.3')) score += 8; // Insecure sharing

  // HR
  if (getValue('J3.1')) score += 5;
  if (getValue('J3.2')) score += 5;
  if (getValue('J3.3')) score += 3;

  // EdTech
  if (getValue('J4.1')) score += 5;
  if (getValue('J4.2')) score += 3;

  // E-commerce
  if (getValue('J5.1')) score += 3;
  if (getValue('J5.2')) score += 3;

  // Determine risk level
  let level;
  if (score <= 20) {
    level = 'Low Risk';
  } else if (score <= 40) {
    level = 'Moderate Risk';
  } else if (score <= 60) {
    level = 'High Risk';
  } else {
    level = 'Critical Risk';
  }

  return { score, level };
};

export { calculateRiskScore };

